import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, Fields, reduxForm, getFormValues } from 'redux-form';

import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';
import CheckboxButtonField from 'components/fields/CheckboxButtonField';
import DateRangeFields from 'components/fields/DateRangeFields';

const styles = () => ({
  gridItemShrink: {
    flexShrink: 1,
    minWidth: 0,
  },
});

function onChange(values, dispatch, props) {
  if (values['Selected Notes Category']) {
    if (!values['Notes Category']
      || values['Notes Category'].findIndex(item =>
        item.value === values['Selected Notes Category'].value) === -1) {
      props.array.push('Notes Category', values['Selected Notes Category']);
    }
    props.clearFields(false, false, 'Selected Notes Category');
  }
  if (values['Selected Author']) {
    if (!values.Author
      || values.Author.findIndex(item =>
        item.value === values['Selected Author'].value) === -1) {
      props.array.push('Author', values['Selected Author']);
    }
    props.clearFields(false, false, 'Selected Author');
  }
}

const OrderNotesFilterForm = ({
  handleSubmit,
  change,
  actions,
  className,
  formValues,
  filterInputRef,
  filterOptions,
  theme,
  classes,
}) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Grid
      container
      spacing={24}
    >
      <Grid item>
        <Field
          id="Intake"
          name="Intake"
          label="Intake"
          color={theme.palette.states.intake}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Delivery"
          name="Delivery"
          label="Delivery"
          color={theme.palette.states.delivery}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Billing"
          name="Billing"
          label="Billing"
          color={theme.palette.states.billing}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Collection"
          name="Collection"
          label="Collection"
          color={theme.palette.states.collection}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Paid"
          name="Paid"
          label="Paid"
          color={theme.palette.states.paid}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="General"
          name="General"
          label="General"
          color={theme.palette.states.archive}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
    </Grid>
  </form>
);

OrderNotesFilterForm.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  filterInputRef: PropTypes.func,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      states: PropTypes.shape({
        intake: PropTypes.string.isRequired,
        delivery: PropTypes.string.isRequired,
        billing: PropTypes.string.isRequired,
        collection: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

OrderNotesFilterForm.defaultProps = {
  onCancelButtonClick: () => {},
  initialValues: {},
  error: null,
  onSubmitButtonBlur: () => {},
  inputRef: () => {},
  onSubmitButtonClick: () => {},
  className: '',
  filterInputRef: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  formValues: getFormValues(ownProps.form)(store),
});

export default connect(mapStateToProps)(
  reduxForm({
    onChange,
  })(withStyles(styles, { withTheme: true })(OrderNotesFilterForm)),
);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderNotes/OrderNotesFilterForm.js